<template lang="">
  <div class="app">
    <img class="bgimg" :src="urls() + '/fwsyapi/src/bing.php'" />
    <div class="demo-login">
      <h1 class="title" v-text="$store.state.title"></h1>
      <Login @on-submit="handleSubmit">

        <UserName name="username" />

        <Password name="password" />

        <Captcha class="demo-login-captcha" name="captcha" :count-down="0">
          <template #text>
            <img
              id="code"
              :src="urls() + '/fwsyapi/getcode/'"
              onclick="this.src=this.src+'?'+Math.random();"
            />
          </template>
        </Captcha>

        <Submit
          style="
            background: #09aefa;
            border: #09aefa solid 1px;
            border-radius: 6px;
          "
        />

      </Login>
    </div>
  </div>
</template>
<script>
import { login, url } from "@/api/index";
export default {
  data() {
    return {};
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    urls() {
      return url();
    },
    handleSubmit(valid, { username, password, captcha }) {
      if (valid) {
        login({
          name: username,
          pwd: password,
          key: captcha,
        }).then((res) => {
          if (res == "0") {
            this.$Modal.error({
              title: "错误",
              content: "验证码错误！",
            });
            const code = document.getElementById("code");
            code.src = code.src + "?" + Math.random();
          } else if (res == 1) {
            this.$Modal.error({
              title: "错误",
              content: "账号或密码错误！",
            });
            const code = document.getElementById("code");
            code.src = code.src + "?" + Math.random();
          } else {
            var token = res.key;
            sessionStorage.setItem("JigGyrBuasd", token);
            this.$message.success("登陆成功");
            if (this._isMobile()) {
              this.$router.replace("/mobile");
            } else {
              this.$router.push("/");
            }
          }
        });
      }
    },
  },
};
</script>
<style >
.app {
  width: auto !important;
}

.app {
  width: 100vw;
  height: 100vh;
  /* background: red; */
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
}

.bgimg {
  width: 105%;
  height: 103%;
  object-fit: cover;
  object-position: 50% 20%;
  z-index: 1;

  filter: blur(3px);
  -webkit-filter: blur(3px);
  -ms-filter: blur(3px);
  -moz-filter: blur(3px);
}

.title {
  color: white;
  position: absolute;
  top: -100px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 3em;
}

.demo-login {
  width: 100vw !important;
  max-width: 500px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  margin: 0 auto;
  z-index: 3;
  padding: 50px;
  padding-bottom: 60px;
  border-radius: 6px;
}

.demo-login-captcha .ivu-btn {
  padding: 0;
}

.demo-login-captcha .ivu-btn img {
  height: 28px;
  position: relative;
  top: 4px;
}</style>
